import _ from 'lodash';

import * as ModalManagerModels from 'containers/ModalManager/models';

export const takeModalWindowResponse = (modalWindowId: string) => ({ payload }: ModalManagerModels.Action.IHideModal): boolean => {
  return _.get(payload, 'id') === modalWindowId;
};
